import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const typographyFn = /* @__PURE__ */ createRecipe('typography', {
  "variant": "body"
}, [])

const typographyVariantMap = {
  "variant": [
    "inherit",
    "headline",
    "headline.xl",
    "headline.xlGotham",
    "headline.large",
    "headline.small",
    "headline.smaller",
    "heading.h1",
    "heading.h5",
    "heading.h6",
    "body",
    "body.large",
    "body.largeBold",
    "body.small",
    "body.responsive",
    "title",
    "title.small",
    "text",
    "text.large",
    "text.largeBold",
    "text.bold",
    "text.small",
    "text.smallBold",
    "text.extraSmall",
    "accent",
    "accent.small",
    "notes.small",
    "notes.highlightSmall",
    "breadcrumb",
    "ltoLabel"
  ]
}

const typographyVariantKeys = Object.keys(typographyVariantMap)

export const typography = /* @__PURE__ */ Object.assign(memo(typographyFn.recipeFn), {
  __recipe__: true,
  __name__: 'typography',
  __getCompoundVariantCss__: typographyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: typographyVariantKeys,
  variantMap: typographyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, typographyVariantKeys)
  },
  getVariantProps: typographyFn.getVariantProps,
})